var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestTube = function SvgTestTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "m11.67 4.166-8.336 8.333A2.946 2.946 0 0 0 7.5 16.667l8.337-8.334M11.67 4.166l4.167 4.167M11.67 4.166l-.837-.833m5.004 5 .83.833m-3.959 1.667H5.625m11.042-5.834h.008m-1.342-2.916h.167m.333 0a.417.417 0 1 1-.833 0 .417.417 0 0 1 .833 0"
  })));
};
export default SvgTestTube;